import {
  LOAD_AGENCY_METRICS,
  LOAD_AGENCY_METRICS_ERROR,
  LOAD_EMPLOYER_METRICS,
  LOAD_EMPLOYER_METRICS_ERROR,
  TOGGLE_FINISH_JOB_POST_MODAL,
} from "../actions/types";

const initialState = {
  agencyMetrics: null,
  employerMetrics: null,
  errors: {},
  finishJobPostModalActive: false,
  loading: true,
  recruiter: {},
};

export default function dashboardReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_AGENCY_METRICS:
      return {
        ...state,
        loading: false,
        agencyMetrics: payload.data,
        recruiter: payload.recruiter,
        errors: {},
      };
    case LOAD_AGENCY_METRICS_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case LOAD_EMPLOYER_METRICS:
      return {
        ...state,
        loading: false,
        employerMetrics: payload,
        errors: {},
      };
    case LOAD_EMPLOYER_METRICS_ERROR:
      return {
        ...state,
        loading: false,
        errors: payload,
      };
    case TOGGLE_FINISH_JOB_POST_MODAL:
      return {
        ...state,
        finishJobPostModalActive: !state.finishJobPostModalActive,
        finishJobPostData: payload.attributes(),
      };
    default:
      return state;
  }
}
